/**
 * SideMenuList.js - Histopathology-only project (per BRD).
 * Returns flat menu (getSideMenus) and tree menu (getSideMenuTree) for left drawer.
 * Tree: all items in left drawer with collapsible sections; no tabs in content.
 */
import ImagePaths from "./ImagePaths";
import { canViewSideMenu, canViewTab } from "./Services/RoleAccessService";

const HISTO_TREE = [
  {
    id: 1,
    menuName: "Histopathology Home",
    label: "Billing",
    OnIcon: ImagePaths.HistoBillingFill,
    OffIcon: ImagePaths.HistoBilling,
    path: "/HistopathologyHome/NewBill",
    children: [
      { menuName: "New Bill", path: "/HistopathologyHome/NewBill" },
      { menuName: "Existing Bill", path: "/HistopathologyHome/ExistingBill" },
      // { menuName: "Histopathology Report", path: "/HistopathologyHome/HistopathologyReport" },
      // { menuName: "Demographics", path: "/HistopathologyHome/Demographics" },
      // { menuName: "Histopathology Billing", path: "/HistopathologyHome/HistopathologyQuickBilling" },
      // { menuName: "Hospital Billing", path: "/HistopathologyBilling/HospitalBilling" },
      // { menuName: "Cash Counter", path: "/HistopathologyBilling/CashCounter" },
    ],
  },
  {
    id: 2,
    menuName: "Histopathology Specimen",
    label: "Specimen",
    OnIcon: ImagePaths.HistoSpecimanFill,
    OffIcon: ImagePaths.HistoSpeciman,
    path: "/HistopathologySpecimen/SpecimenCollection",
    children: [
      { menuName: "Specimen Collection", path: "/HistopathologySpecimen/SpecimenCollection" },
      { menuName: "Outsource Test", path: "/HistopathologySpecimen/OutsourceTest" },
    ],
  },
  {
    id: 7,
    menuName: "Histopathology Billing Transaction",
    label: "Billing Transaction",
    OnIcon: ImagePaths.HistoBillingFill,
    OffIcon: ImagePaths.HistoBilling,
    path: "/HistopathologyBillingTransaction/OverallBills",
    children: [
      { menuName: "Overall Bills", path: "/HistopathologyBillingTransaction/OverallBills" },
      { menuName: "Credit Bills", path: "/HistopathologyBillingTransaction/CreditBills" },
      { menuName: "Receipt Bills", path: "/HistopathologyBillingTransaction/ReceiptBills" },
    ],
  },
  {
    id: 3,
    menuName: "Histopathology Reporting",
    label: "Reporting",
    OnIcon: ImagePaths.HistoReportingFill,
    OffIcon: ImagePaths.HistoReporting,
    path: "/HistopathologyReporting/PendingList",
    children: [
      { menuName: "Pending List", path: "/HistopathologyReporting/PendingList" },
      { menuName: "Approval List", path: "/HistopathologyReporting/ApprovalList" },
      { menuName: "Completed List", path: "/HistopathologyReporting/CompletedList" },
    ],
  },
  {
    id: 4,
    menuName: "Histopathology Credit Settlement",
    label: "Credit Settlement",
    OnIcon: ImagePaths.Settlementon,
    OffIcon: ImagePaths.Settlementoff,
    path: "/HistopathologyCreditSettlement/CorporateProvider",
    children: [
      { menuName: "Hospital Settlement", path: "/HistopathologyCreditSettlement/CorporateProvider" },
      { menuName: "Settlement Report", path: "/HistopathologyCreditSettlement/SettlementReport" },
    ],
  },
  {
    id: 5,
    menuName: "Histopathology Reports",
    label: "Reports",
    OnIcon: ImagePaths.LabReportOn,
    OffIcon: ImagePaths.LabReportOff,
    path: "/HistopathologyReports/OutsourceReport",
    children: [
      { menuName: "Outsource Report", path: "/HistopathologyReports/OutsourceReport" },
      { menuName: "TAT Report", path: "/HistopathologyReports/TATReport" },
    ],
  },
  {
    id: 6,
    menuName: "Histopathology Setting",
    label: "Masters",
    OnIcon: ImagePaths.LabSettingOn,
    OffIcon: ImagePaths.LabSettingOff,
    path: "/HistopathologySetting/MasterConfiguration/ServiceMaster",
    children: [
      { menuName: "Service Master", path: "/HistopathologySetting/MasterConfiguration/ServiceMaster" },
      { menuName: "Result Template", path: "/HistopathologySetting/MasterConfiguration/ResultTemplate" },
      { menuName: "Specimen Master", path: "/HistopathologySetting/MasterConfiguration/SpecimenMaster" },
      { menuName: "Demographics Layout", path: "/HistopathologySetting/ClinicConfiguration/DemographicsLayout" },
      { menuName: "Outsource Configuration", path: "/HistopathologySetting/ClinicConfiguration/OutSourceConfiguration" },
      { menuName: "E-Sign Configuration", path: "/HistopathologySetting/ClinicConfiguration/eSignConfiguration" },
      { menuName: "Referred Doctor", path: "/HistopathologySetting/ClinicConfiguration/ReferredDoctor" },
      { menuName: "Custom Configuration", path: "/HistopathologySetting/ClinicConfiguration/CustomConfiguration" },
      { menuName: "Hospital Configuration", path: "/HistopathologySetting/ClinicConfiguration/CorporateConfiguration" },
      { menuName: "Role Access", path: "/HistopathologySetting/UserConfiguration/RoleAccess" },
      { menuName: "User Configuration", path: "/HistopathologySetting/UserConfiguration/UserConfig" },
    ],
  },
];

export const NewSideMenu = {
  Histopathology: (getItem) => {
    const myUser = JSON.parse((getItem && getItem("loggedInUserInfo")) || "{}");
    const newList = [];
    if (myUser?.module_name === "Histopathology") {
      const allItems = [
        { id: 1, menuName: "Histopathology Home", OnIcon: ImagePaths.HistoBillingFill, OffIcon: ImagePaths.HistoBilling, label: "Billing" },
        { id: 2, menuName: "Histopathology Specimen", OnIcon: ImagePaths.HistoSpecimanFill, OffIcon: ImagePaths.HistoSpeciman, label: "Specimen" },
        { id: 7, menuName: "Histopathology Billing Transaction", OnIcon: ImagePaths.HistoBillingFill, OffIcon: ImagePaths.HistoBilling, label: "Billing Transaction" },
        { id: 3, menuName: "Histopathology Reporting", OnIcon: ImagePaths.HistoReportingFill, OffIcon: ImagePaths.HistoReporting, label: "Reporting" },
        { id: 4, menuName: "Histopathology Credit Settlement", OnIcon: ImagePaths.Settlementon, OffIcon: ImagePaths.Settlementoff, label: "Credit Settlement" },
        { id: 5, menuName: "Histopathology Reports", OnIcon: ImagePaths.LabReportOn, OffIcon: ImagePaths.LabReportOff, label: "Reports" },
        { id: 6, menuName: "Histopathology Setting", OnIcon: ImagePaths.LabSettingOn, OffIcon: ImagePaths.LabSettingOff, label: "Masters" },
      ];
      allItems.filter((item) => canViewSideMenu(item.label)).forEach((item) => newList.push(item));
    }
    return newList;
  },
  default: () => [],
};

export function getSideMenus(getItem) {
  const myUser = JSON.parse((getItem && getItem("loggedInUserInfo")) || "{}");
  return myUser?.module_name === "Histopathology" ? NewSideMenu.Histopathology(getItem) : NewSideMenu.default();
}

/**
 * Returns tree menu for left drawer: top-level filtered by canViewSideMenu,
 * children filtered by canViewTab. Only nodes with at least one visible child are included.
 */
export function getSideMenuTree(getItem) {
  const myUser = JSON.parse((getItem && getItem("loggedInUserInfo")) || "{}");
  if (myUser?.module_name !== "Histopathology") return [];

  return HISTO_TREE.filter((item) => canViewSideMenu(item.label)).map((parent) => {
    const visibleChildren = (parent.children || []).filter((child) => canViewTab(child.menuName));
    return { ...parent, children: visibleChildren };
  }).filter((parent) => parent.children?.length > 0);
}
